export const SUBCONTENT_MAX_WIDTH = 192; // in sizing units
